import _ from 'lodash';

import {
  ADD_WARNING,
  ADD_WARNINGS,
  CLEAR_WARNINGS,
  ENABLE_ALL_WARNINGS,
  REMOVE_WARNING_BY_ID_AND_MESSAGE,
  TOGGLE_WARNINGS_BY_REF,
  UPDATE_ALL_WARNINGS,
} from '../actions/WarningActions';
import { START_AUTO_CHECKING } from '../actions/WorkflowActions';

export default (state = [], action) => {
  switch (action.type) {
    case ADD_WARNING: {
      const warn = {
        message: action.message,
        instanceId: action.instanceId,
        controlInfo: action.controlInfo,
        source: action.source,
        ref: action.ref,
        warningEnabled: action.warningEnabled ?? false,
        preventsFormSubmission: action.preventsFormSubmission,
      };

      const isWarningDuplicated =
        state.find((w) => w.instanceId === warn.instanceId && w.message === warn.message) !==
        undefined;

      return isWarningDuplicated ? state : [...state, warn];
    }

    case ADD_WARNINGS: {
      return _.uniqWith(
        [...state, ...action.warnings],
        (w1, w2) => w1.instanceId === w2.instanceId && w1.message === w2.message
      );
    }

    case TOGGLE_WARNINGS_BY_REF: {
      const { ref, flag } = action.payload;

      return state.map((w) => (w === ref ? { ...w, warningEnabled: flag } : w));
    }

    case ENABLE_ALL_WARNINGS:
    case START_AUTO_CHECKING: {
      return state.map((w) => ({ ...w, warningEnabled: true }));
    }

    case REMOVE_WARNING_BY_ID_AND_MESSAGE:
      return state.filter(
        (w) => w.instanceId !== action.payload.instanceId || w.message !== action.payload.message
      );

    case CLEAR_WARNINGS:
      if (typeof action.sourceFilter === 'function') {
        return state.filter(action.sourceFilter);
      }
      if (typeof action.sourceFilter === 'string') {
        return state.filter((warning) => warning.source !== action.sourceFilter);
      }
      return [];

    case UPDATE_ALL_WARNINGS:
      return action.payload.newWarnings;

    default:
      return state;
  }
};
